
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Erreurs à éviter pour réussir vos campagnes Facebook Ads",
    description:
      "Découvrez les erreurs courantes à éviter pour optimiser vos campagnes Facebook Ads. ALEO vous accompagne pour une stratégie performante et des résultats concrets.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
